import { ReadDerc20 } from './chunk-5P4MDDZZ.mjs';
import { createDrift } from '@delvtech/drift';

var ReadWriteDerc20 = class extends ReadDerc20 {
  constructor(address, drift = createDrift()) {
    super(address, drift);
  }
  async approve(spender, value) {
    return this.contract.write("approve", { spender, value });
  }
  async release(amount, options) {
    return this.contract.write("release", {}, options);
  }
};

export { ReadWriteDerc20 };
//# sourceMappingURL=chunk-GQCYGUBI.mjs.map
//# sourceMappingURL=chunk-GQCYGUBI.mjs.map